<template>
  <div class="form-group row">
    <label
      :for="inputId"
      :class="['col-form-label', colLabel, required ? 'required' : null]"
    >{{ labelText }}</label>
    <div :class="[colInput]">
      <select
        :id="inputId"
        :ref="typeSelect"
        class="form-control"
      >
        <option />
        <option
          v-for="(value, key) in options"
          :key="key"
          :value="key"
        >
          {{ value }}
        </option>
      </select>
      <span
        v-if="eMsg"
        class="text-danger"
      >{{ eMsg }}</span>
    </div>
  </div>
</template>

<script>
import $ from "jquery"
import select2 from 'select2';

export default {
  name: 'InputSelect2',
  props: {
    inputId: {
      type: String,
      required: true
    },
    labelText: {
      type: String,
      required: true
    },
    options: {
      type: Object,
      required: true
    },
    selected: {
      type: [Number, String],
      default: 0
    },
    typeSelect: {
      type: String,
      required: true
    },
    eMsg: {
      type: String,
      default: ""
    },
    placeHolder: {
      type: String,
      default: ""
    },
    colLabel: {
      type: String,
      default: "col-lg-2"
    },
    colInput: {
      type: String,
      default: "col-lg-10"
    },
    required: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {};
  },
  watch: {
    selected(newValue) {
      $(`#${this.inputId}`).val(newValue).trigger("change");
    }
  },
  created(){
    select2();
  },
  updated() {
    $(`#${this.inputId}`).val(this.selected).trigger("change");
  },
  mounted() {
    const vm = this;
    $(`#${vm.inputId}`)
      .select2({
        data: vm.options,
        width: "100%",
        allowClear: true,
        placeholder: vm.placeHolder
      })
      .on("select2:select select2:unselect", (e) => {
        vm.$emit("update:selected", e.target.value);
      })
      .on("select2:open", () => {
        $(".select2-search__field")[0].focus();
      });
  },
  beforeUnmount() {
    $(`#${this.inputId}`).off().select2("destroy");
  }
};
</script>

<style lang="scss" scoped>
  .form {
    margin-bottom: 6px;
  }

  label.required::after {
    content: "*";
    display: inline-block;
  } 
</style>
